import Layout from '@/layout'

/**
 * 治理系统路由
 * GovernSystemWorkBenchManualList 风控工作台-列表
 * GovernSystemWorkBenchLit 风控工作台-人工处理详情
 * GovernSystemBatchOperationRecord 批导操作记录
 * 策略配置平台相关页面
 *  策略组 PolicyGroup
 *
 */

const governRouter = {
  // GovernSystem: () => import('@/views/govern-system/index'),
  GovernSystemWorkBenchManualList: () => import('@/views/govern-system/manual-judgment-work-bench/index'),
  GovernSystemBatchOperationRecord: () =>
    import('@/views/govern-system/batch-operation-record/index'),
  ViolationCenterList: () => import('@/views/govern-system/violation-center/index'),
  // 策略配置平台相关页面
  PolicyGroup: () => import('@/views/govern-system/policy-configuration-platform/policy-group/PolicyGroupList'), // 策略组
  PolicyRule: () => import('@/views/govern-system/policy-configuration-platform/rule/PolicyRuleList'), // 策略规则
  PolicyManage: () => import('@/views/govern-system/policy-configuration-platform/policy/PolicyList'), // 策略
  PolicyLabelList: () => import('@/views/govern-system/policy-configuration-platform/policy-label/PolicyLabelList'), // 策略标签
  // 处置配置平台相关
  // 处置方案管理
  DisposalSchemeList: () => import('@/views/govern-system/disposal-configuration-platform/disposal-scheme/DisposalSchemeList'),
  DriverControlCenterServiceScore: () => import('@/views/govern-system/driver-control-center/service-score/index'),
}

const governRouters = [
  {
    path: '/manual-judgment-work-bench',
    component: Layout,
    name: 'ManualJudgmentWorkBench',
    children: [
      {
        path: '/manual-judgment-work-bench/detail/:id',
        component: () => import('@/views/govern-system/manual-judgment-work-bench/detail'),
        name: 'ManualJudgmentWorkBenchDetail',
        hidden: true,
        meta: { title: '工作台详情', noCache: true }
      },
      {
        path: '/manual-judgment-work-bench/manual-judgment/:id',
        component: () => import('@/views/govern-system/manual-judgment-work-bench/manual-judgment'),
        name: 'ManualJudgmentWorkBenchJudgment',
        hidden: true,
        meta: { title: '判责受理', noCache: true }
      }
    ]
  },
  {
    path: '/policy-group-layout',
    component: Layout,
    name: 'PolicyGroupLayout',
    children: [
      {
        path: '/policy-group-layout/Detail',
        component: () => import('@/views/govern-system/policy-configuration-platform/policy-group/PolicyGroupDetail'),
        name: 'PolicyGroupDetail',
        meta: { title: '策略组详情', noCache: true }
      },
      {
        path: '/policy-group-layout/add',
        component: () => import('@/views/govern-system/policy-configuration-platform/policy-group/AddPolicyGroup'),
        name: 'AddPolicyGroup',
        meta: { title: '新增策略组', noCache: true }
      },
    ]
  },
  {
    path: '/policy-manage-layout',
    component: Layout,
    name: 'PolicyManageLayout',
    children: [
      {
        path: '/policy-manage-layout/config',
        component: () => import('@/views/govern-system/policy-configuration-platform/policy/PolicyConfig'),
        name: 'PolicyConfig',
        meta: { title: '新增策略配置', noCache: true }
      },
      {
        path: '/policy-manage-layout/config-detail',
        component: () => import('@/views/govern-system/policy-configuration-platform/policy/PolicyConfigDetail'),
        name: 'PolicyConfigDetail',
        meta: { title: '策略配置详情', noCache: true }
      },
      {
        path: '/policy-manage-layout/detail',
        component: () => import('@/views/govern-system/policy-configuration-platform/policy/PolicyDetail'),
        name: 'PolicyDetail',
        meta: { title: '策略详情', noCache: true }
      },
      {
        path: '/policy-manage-layout/add',
        component: () => import('@/views/govern-system/policy-configuration-platform/policy/AddPolicy'),
        name: 'AddPolicy',
        meta: { title: '新增策略', noCache: true }
      }
    ]
  }, {
    path: '/policy-rule',
    component: Layout,
    name: 'PolicyRuleLayout',
    children: [
      {
        path: '/policy-rule/add',
        component: () => import('@/views/govern-system/policy-configuration-platform/rule/AddPolicyRule'),
        name: 'AddPolicyRule',
        meta: { title: '新增规则', noCache: true }
      },
      {
        path: '/policy-rule/detail',
        component: () => import('@/views/govern-system/policy-configuration-platform/rule/PolicyRuleDetail'),
        name: 'PolicyRuleDetail',
        meta: { title: '规则详情', noCache: true }
      }
    ]
  }, {
    path: '/disposal-scheme',
    component: Layout,
    name: 'DisposalSchemeLayout',
    children: [
      {
        path: '/disposal-scheme/add',
        component: () => import('@/views/govern-system/disposal-configuration-platform/disposal-scheme/AddDisposalScheme'),
        name: 'AddDisposalScheme',
        meta: { title: '新增处置方案', noCache: true }
      },
      {
        path: '/disposal-scheme/detail',
        component: () => import('@/views/govern-system/disposal-configuration-platform/disposal-scheme/DisposalSchemeDetail'),
        name: 'DisposalSchemeDetail',
        meta: { title: '处置方案详情', noCache: true }
    }]
  },
  {
    path: '/driver-control-center',
    component: Layout,
    name: 'DriverControlCenterLayout',
    children: [
      {
        path: '/govern-system/driver-control-center/service-score/index',
        component: () => import('@/views/govern-system/driver-control-center/service-score/index'),
        name: 'DriverControlCenterServiceScoreIndex',
        meta: { title: '司机等级列表', noCache: true }
      },
      {
        path: '/govern-system/driver-control-center/service-score/config',
        component: () => import('@/views/govern-system/driver-control-center/service-score/detail'),
        name: 'DriverControlCenterServiceScoreDetail',
        meta: { title: '司机等级详情', noCache: true }
      },
      {
        path: '/govern-system/driver-control-center/service-score/add-config',
        component: () => import('@/views/govern-system/driver-control-center/service-score/config'),
        name: 'DriverControlCenterServiceScoreAddConfig',
        meta: { title: '新增司机等级', noCache: true }
      },
    ]
  },
]
export {
  governRouter,
  governRouters
}
